(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["new-newsletter-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    (async () => {
      try {
        const postMail = async (profiles) => {
          const url = `https://manage.kmail-lists.com/ajax/subscriptions/subscribe`;

          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Cache-Control': 'no-cache',
            },
            body: profiles,
          });
          return await res.json();
        };

        const sendMail = async (selector, listId) => {
          const elem = document.querySelector(selector);

          const profiles = new URLSearchParams();
          let ElemListName = '';

          const inputElemList = elem.querySelectorAll('input');

          for (let i = 0; i < inputElemList.length; i++) {
            if (inputElemList[i].dataset.name !== 'email') {
              profiles.append('' + inputElemList[i].dataset.name, inputElemList[i].value);
            } else {
              profiles.append(inputElemList[i].dataset.name, inputElemList[i].value);
            }
            if (inputElemList[i].dataset.name !== 'email') {
              if (i !== 0) ElemListName += ',';
              ElemListName += '' + inputElemList[i].dataset.name;
            }
          }

          profiles.append('$fields', ElemListName);
          profiles.append('g', listId);

          const json = await postMail(profiles);

          const infoElem = elem.querySelector('.form__submitted');
          if (json.errors.length !== 0) {
            if (infoElem) console.error(json);
          } else {
            for (let i = 0; i < inputElemList.length; i++) inputElemList[i].value = '';

            if (infoElem) infoElem.style.display = 'block';
          }
        };

        const formContact = document.getElementById('klaviyo-form--small');
        if (formContact) {
          formContact.onsubmit = async (e) => {
            e.preventDefault();
            await sendMail('#klaviyo-form--small', e.target.dataset.listId);
          };
        }
      } catch (e) {
        console.log(e);
      }
    })();
  });
  } catch(e) { console.error(e); }
})();

})();
